/**
 * VAL-DASHBOARD-NEXT-1 — Central-time (America/Chicago) day math for the
 * Dashboard. Calendar days, not 24-hour blocks, so "today" flips at Central
 * midnight.
 */
const CENTRAL = 'America/Chicago'

const dayFmt = new Intl.DateTimeFormat('en-CA', {
  timeZone: CENTRAL, year: 'numeric', month: '2-digit', day: '2-digit',
})

/** Central calendar day as a UTC-midnight epoch day number. */
function centralDay(d: Date): number {
  const [y, m, day] = dayFmt.format(d).split('-').map(Number)
  return Math.floor(Date.UTC(y, m - 1, day) / 86_400_000)
}

/** Whole Central calendar days from `iso` to `now` (never negative). */
export function daysSince(iso: string | null | undefined, now: Date = new Date()): number {
  if (!iso) return 0
  const t = new Date(iso)
  if (Number.isNaN(t.getTime())) return 0
  return Math.max(0, centralDay(now) - centralDay(t))
}

/** `<n> days`, `1 day`, `today`. */
export function daysLabel(n: number): string {
  if (n <= 0) return 'today'
  return n === 1 ? '1 day' : `${n} days`
}

/** Central calendar date, e.g. "Oct 1, 2026". */
export function centralDateLabel(iso: string | null | undefined): string {
  if (!iso) return ''
  const t = new Date(iso)
  if (Number.isNaN(t.getTime())) return ''
  return t.toLocaleDateString('en-US', { timeZone: CENTRAL, year: 'numeric', month: 'short', day: 'numeric' })
}
